import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SelectContainer from './SelectContainer';
import SearchApi from '../../store/api/search';
import {
  setSelectedFunds,
  setARTSelected
} from '../../store/actions/globalActions';
import { filterByEndDate } from './../../utils/funds';

const DefaultFundSection = props => {
  const { funds } = useSelector(state => state.global.data);
  const fundsToDisplay =
    Array.isArray(funds) && funds.length > 0 ? filterByEndDate(funds) : [];
  const { employer } = props;
  const dispatch = useDispatch();
  const isInternalFundChange = useRef(false);

  const handleSelectionChange = updatedFunds => {
    const currentFunds = updatedFunds || funds || [];
    const validFundsToUpdate = currentFunds.filter(fundItem => {
      const hasUsi = !!fundItem.usi; // funds without a USI are invalid and must never be sent to the BE
      const hasEnd = !!fundItem.endDate;
      const hasProduct = !!fundItem.productName;
      const isExisting = // defaultFundId is only assigned to existing default funds, new funds will not have this property until they are saved and returned from the API with an id
        fundItem.defaultFundId != null &&
        fundItem.defaultFundId !== '' &&
        Number(fundItem.defaultFundId) >= 0;

      return hasUsi && ((!isExisting && hasProduct && !hasEnd) || isExisting); // new valid fund without end date, or existing fund (regardless of end date); invalid (no USI) funds are excluded
    });

    isInternalFundChange.current = true;
    props.onChange({ ...employer, defaultFunds: validFundsToUpdate });
  };

  const getAllDefaultFundDetails = async defaultFunds => {
    try {
      // let fundDetails = [];
      const USIs = defaultFunds.map(defaultFundItem => defaultFundItem.usi);
      if (USIs.length > 0) {
        // get funds details
        const fundDetailPromises = USIs.map(usi => {
          if (!usi) {
            // don't look up funds without a USI; keep them so they stay visible and removable
            return Promise.resolve({ uniqueSuperannuationIdentifier: usi });
          }
          return SearchApi.getFundDetails('usi', usi)
            .then(
              fundsInfo =>
                fundsInfo[0]
                  ? fundsInfo[0]
                  : { uniqueSuperannuationIdentifier: usi } // still return usi even if not found
            )
            .catch(err => {
              console.warn(err);
              return null;
            });
        });

        const res = await Promise.all(fundDetailPromises);

        const mappedFunds = res.map(fundResult => {
          const { defaultFundId, endDate, startDate } = defaultFunds.find(
            defaultFundItem =>
              defaultFundItem.usi === fundResult.uniqueSuperannuationIdentifier
          );

          return {
            usi: fundResult.uniqueSuperannuationIdentifier,
            australianBusinessNumber: fundResult.australianBusinessNumber,
            productName: fundResult.productName,
            defaultFundId,
            endDate,
            startDate
          };
        });

        dispatch(setSelectedFunds(mappedFunds));
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(
    () => {
      // Skip the reset when the employer change was triggered by an internal
      // fund selection (selecting / removing a fund).  Only re-initialise when
      // the employer genuinely changes (e.g. switching employer in the list).
      if (isInternalFundChange.current) {
        isInternalFundChange.current = false;
        return;
      }
      dispatch(setSelectedFunds([]));
      dispatch(setARTSelected(false));
      if (
        employer &&
        employer.defaultFunds &&
        employer.defaultFunds.length > 0
      ) {
        getAllDefaultFundDetails(employer.defaultFunds);
      }
    },
    [employer]
  );

  return (
    <div>
      <SelectContainer
        onSelectUpdate={handleSelectionChange}
        fundsToDisplay={fundsToDisplay}
      />
    </div>
  );
};

export default DefaultFundSection;
